"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_battery__low(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "498517aa-a88e-4f9d-affe-28c0fc21cf6f",
    "data-name": "battery-hi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "7eeefd02-d387-49b5-9a3e-4d9326797ec4",
    x1: 149.66,
    y1: 88.99,
    x2: 174.81,
    y2: 114.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "battery-low-hi"), /*#__PURE__*/React.createElement("g", {
    id: "de869932-cbbc-4b0f-b401-8e886f2126b4",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "075589dc-14bf-476a-ab63-b78957e0d805",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d08675e1-502a-4031-ac4e-13ea187a32bf",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e64e40ed-492f-4d31-a436-18e87ad32804",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2435cab5-357f-4a22-9fe0-3c56ac8c9eb3",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "940b640c-b26b-456f-85a7-55f4b5c184c6",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c80de6f2-40ae-43ae-955e-2371cef55c0b",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6b14c399-2abb-49ad-8b42-93ffb9d630ae",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,84V72a16,16,0,0,0-16-16H32A16,16,0,0,0,16,72v48a16,16,0,0,0,16,16H144a16,16,0,0,0,16-16V84Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,120h4a12,12,0,0,0,12-12V84a12,12,0,0,0-12-12h-4",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160,120h4a12,12,0,0,0,12-12V84a12,12,0,0,0-12-12h-4",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160,120h4a12,12,0,0,0,12-12V84a12,12,0,0,0-12-12h-4",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 108,
    x2: 44,
    y2: 84,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 108,
    x2: 68,
    y2: 84,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92,
    y1: 108,
    x2: 92,
    y2: 84,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,120a12,12,0,0,0,12-12V94.65l-16-16V120Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#7eeefd02-d387-49b5-9a3e-4d9326797ec4)"
  }))))))))), /*#__PURE__*/React.createElement("path", {
    d: "M144,134H32a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H144a16,16,0,0,0,16-16v-2A16,16,0,0,1,144,134Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,118h-4v2h4a12,12,0,0,0,12-12v-2A12,12,0,0,1,164,118Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }));
}

var _default = ic_battery__low;
exports.default = _default;